// extracted by css-extract-rspack-plugin
var _1 = "SuJ5oKLq3pEjKhCEkqP4vQ--";
var _2 = "aboYA8JExnzcKcaUT67BAQ--";
export { _1 as "tutorialButton", _2 as "tutorialButtonOpen" }
